import { taxaDoPerfil, type TaxaDeUrgencia } from "@bookdental/schemas";
import { trpc } from "./trpc";

/** Taxa de urgência configurada pelo laboratório ativo (null = sem taxa). Mesma consulta do perfil
 *  que o prazo usa, cacheada. */
export function useTaxaDeUrgencia(): TaxaDeUrgencia | null {
  return taxaDoPerfil(trpc.organization.getProfiles.useQuery().data?.labProfile);
}

/** "R$ 50,00" ou "20% dos serviços". */
export function rotuloDaTaxa(taxa: TaxaDeUrgencia): string {
  return taxa.tipo === "FIXA"
    ? (taxa.valor / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : `${taxa.valor}% dos serviços`;
}
